import { SwitchableCollection, SwitchableData } from "./functions";
import { filterListingBySearch } from "./functions";
import SwitchableIndexItem from "./index-item";

export interface CollectionProps {
  chairs: SwitchableData[];
  collection: SwitchableCollection;
  search: string;
}

function MassageChairsIndexCollection({
  chairs,
  collection,
  search,
}: CollectionProps) {
  const results = filterListingBySearch(chairs, search);
  return (
    <section className="brand3d-page-content">
      {results.length ? (
        <>
          <div className="brand3d-section-title">
            <hr />
            <h1>{collection.name}</h1>
          </div>
          <ul className="brand3d-experience-index">
            {results.map(
              (experience: SwitchableData): JSX.Element => (
                <SwitchableIndexItem
                  key={`${experience.id}`}
                  experience={experience}
                />
              ),
            )}
          </ul>
        </>
      ) : null}
    </section>
  );
}

export default MassageChairsIndexCollection;
